import defaultTheme from './defaultTheme';
const oneTravelTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#142535', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#142535', background: '#142535' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#142535' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#142535', border: '#142535', background: '#142535' }), field: {
        focus: '#142535',
        label: '#142535',
        icon: '#142535',
    } });
export default oneTravelTheme;
